<template>
  <div :class="['aiaibot-message-info tw-my-2 tw-text-right tw-text-12 tw-text-gray-darker tw-leading-4', { isOutgoing }]">
    {{ isOutgoing ? (customerName || t('aiaibot_you')) : agentName }},
    <template v-if="day">
      {{ day }} - 
    </template>
    {{ time }}
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { useI36n } from '@jota-one/i36n/src/index.vue2'
import { formatDate, isSameDay } from '@/helpers/helpers'

export default defineComponent({
  name: 'AiaiBotMediaMessageHeader',
  props: {
    date: {
      type: Date,
      default: () => new Date()
    },
    isOutgoing: {
      type: Boolean
    },
    customerName: {
      type: String,
      default: ''
    },
    agentName: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { $label: t } = useI36n()

    const day = computed(() => {
      if (!props.date || isSameDay(props.date, new Date())) {
        return
      }

      return formatDate(props.date)
    })

    const time = computed(() => {
      if (!props.date) {
        return
      }

      const h = props.date.getHours()
      const m = String(props.date.getMinutes()).padStart(2, '0')
      return `${h}:${m}`
    })

    return { t, day, time }
  },
  methods: {
    formatDate
  }
})
</script>

<style lang="postcss" scoped>
.aiaibot-message-info.isOutgoing {
  text-align: left;
}
</style>
